import { render, staticRenderFns } from "./GoodsSku.vue?vue&type=template&id=3e899104&scoped=true"
import script from "./GoodsSku.vue?vue&type=script&lang=js"
export * from "./GoodsSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e899104",
  null
  
)

export default component.exports